module.exports = __webpack_public_path__ + "img/border_heart.898778e4.svg";